import React from 'react';
import { createPortal } from 'react-dom';
import './FilePreparationModal.css';
import { CommonModal, CrossButton } from 'components';

const FilePreparationModal = (props) => {

  const { closeModal, title, message, onStatementHistory } = props;

  const statementHistory = () => {
    onStatementHistory()
    closeModal()
  }

  const propsModalInhance = {
    ...props,
    onSubmit: statementHistory
  }

  return (
    <>

      {/* Modal */}
      <CommonModal {...propsModalInhance}>


        {/* Icon */}
        {/* <div className="fp-icon-wrapper">
          <div className="fp-icon-circle">
            <svg
              className="fp-icon-svg"
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="12" y1="18" x2="12" y2="12"></line>
              <line x1="9" y1="15" x2="15" y2="15"></line>
            </svg>
          </div>
        </div> */}


       


        <div className="addLr_body">
          <div className="fp-modal-content">
            <h2 className="fp-modal-title">
              {title || 'Your File is Being Prepared'}
            </h2>
            <p className="fp-modal-message">
              {message || "This may take a few minutes. We'll notify you via email once your file is ready."}
            </p>
          </div>
        </div>

      </CommonModal>
    </>
  );

};

export default FilePreparationModal;